import { render } from "./AposForgotPasswordForm.vue?vue&type=template&id=113fc9ee&scoped=true"
import script from "./AposForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./AposForgotPasswordForm.vue?vue&type=script&lang=js"

import "./AposForgotPasswordForm.vue?vue&type=style&index=0&id=113fc9ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113fc9ee"],['__file',"login/ui/apos/components/AposForgotPasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "113fc9ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('113fc9ee', __exports__)) {
    api.reload('113fc9ee', __exports__)
  }
  
  module.hot.accept("./AposForgotPasswordForm.vue?vue&type=template&id=113fc9ee&scoped=true", () => {
    api.rerender('113fc9ee', render)
  })

}


export default __exports__